import { useSessionDetailsStore } from "~/store/sessions/session-details-store";
import { useSessionsStore } from "~/store/sessions/sessions-store";
import { useProjectsStore } from "~/store/project/projects.store";
import { useUserDetailStore } from "~/store/users/user-detail.store";
import { useUsersHabilitationsStore } from "~/store/users-habilitations/users-habilitations.store";
import { useEmployeeTrainingsStore } from "~/store/employee-trainings/employee-trainings.store";
import { useDateChoiceStore } from "~/store/date-choice/date-choice.store";
import { useTrainerSessionStore } from "~/store/trainer-activities/trainer-session.store";
import { useLearningPathAttendeeStore } from "~/store/learning-path/learning-path-attendee.store";
import { useLearningPathAttendeesStore } from "~/store/learning-path/learning-path-attendees.store";
import { useRequestsStore } from "~/store/requests/requests.store";
import { useHomeCatalogStore } from "~/store/catalog/home-catalog.store";
import { useTrainingsStore } from "~/store/trainings/trainings.store";
import { useCreateTrainingStore } from "~/store/trainings/create-training.store";
import { useCreateBuilderTrainingStore } from "~/store/trainings/create-training-builder.store";
import { useTrainingPrefillStore } from "~/store/copilot/training-prefill.store";
import { LearningPathAttendeesTabTypeEnum } from "~/utils/enums/learning-path.enums";
import { copilotPageSessionIdOf, copilotResourceContextOf } from "~/utils/helpers/copilot/resource-context";
import { hostsTrainingModal } from "~/utils/helpers/trainings/training-modal-host";

/** Reads existing page state only; no resource fetch or conversation state belongs here. */
export function useCopilotResourceContext() {
  const router = useRouter();
  const session = useSessionDetailsStore();
  const registrations = useSessionsStore();
  const projects = useProjectsStore();
  const users = useUserDetailStore();
  const habilitations = useUsersHabilitationsStore();
  const employee = useEmployeeTrainingsStore();
  const dateChoice = useDateChoiceStore();
  const trainer = useTrainerSessionStore();
  const learningPathAttendee = useLearningPathAttendeeStore();
  const learningPathAttendees = useLearningPathAttendeesStore();
  const requests = useRequestsStore();
  const catalog = useHomeCatalogStore();
  const trainings = useTrainingsStore();
  const trainingEditor = useCreateTrainingStore();
  const trainingBuilder = useCreateBuilderTrainingStore();
  const trainingPrefill = useTrainingPrefillStore();

  return computed(() => {
    const route = router.currentRoute.value;
    const builderOpen = hostsTrainingModal(route) && trainingBuilder.showModal;
    const state = {
      sessionOpen: !!session.sessionViewModal,
      session: session.sessionDetails,
      registrationOpen: !!registrations.showSessionModal,
      registration: registrations.trainingPlanSessionIndividual ?? projects.trainingPlanProjectIndividual,
      learningPathAttendee:
        learningPathAttendees.learningPathAttendeesModal &&
        learningPathAttendees.currentNav?.type === LearningPathAttendeesTabTypeEnum.ATTENDEES &&
        learningPathAttendee.showAttendee
          ? learningPathAttendee.learningPathAttendee
          : null,
      userOpen: users.showModal,
      userId: users.userDetails?.userId ?? null,
      habilitationOpen: habilitations.showUserHabilitationDetailModal,
      habilitationId: habilitations.userHabilitationDetails?.userHabilitationId,
      employeeTrainingOpen: !!employee.showMySessionModal,
      employeeRequestOpen: !!employee.showMyRequestModal,
      requestId: requests.requestDetails?.requestId,
      trainingPageOpen: catalog.showTrainingPageModal || !!trainings.currentUrl,
      trainingPageId: trainings.trainingPageDetails?.trainingId,
      trainingEditorOpen: trainingEditor.showModal || builderOpen,
      trainingEditorId: builderOpen ? trainingBuilder.training.content.trainingId : trainingEditor.trainingId,
      trainingEditorPrefilled: !builderOpen && trainingPrefill.isActive,
      projectUserId: !dateChoice.isLoading && dateChoice.choiceOptions ? dateChoice.projectUserId : null,
      trainerSessionId: trainer.isLoading ? null : trainer.sessionId,
    };
    return {
      resourceContext: copilotResourceContextOf(route, state),
      sessionId: copilotPageSessionIdOf(route, state),
    };
  });
}
